import React from "react";

import classnames from "classnames";
import { useDispatch } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { LabelSmall } from "Cobalt/BodyText";
import Icon from "Common/Icon";

import { favoritePlan } from "./Actions";

import makeBem from "Utils/makeBem";

const bem = makeBem("QuotePagePlanCard");

const ANALYTICS_LOCATION = "expanding_plan_card";

export const FavoriteToggleButton = ({ planId, checked }) => {
  const dispatch = useDispatch();
  const handleFavorite = (e) => {
    e.stopPropagation();
    AnalyticsTracking.trackEvent("quote_page_click_favorite", {
      location: ANALYTICS_LOCATION,
    });

    dispatch(favoritePlan({ planID: planId, location: "plan_card_bottom_right" }));
  };
  const classes = classnames(bem("favorite"), {
    [bem("favorite", "checked")]: checked,
  });

  return (
    <LabelSmall className={classes} onClick={handleFavorite}>
      <Icon icon="heart" flavor={checked ? "solid" : "regular"} size="md" mr={1} />
      Favorite
    </LabelSmall>
  );
};
